import React from 'react'
import { Loader } from '../loader'

const Button = ({children, className, customWidth = 'w-full', thin, disabled, isLoading, ...props}) => {
  return (
    <button
      className={`${disabled ? 'opacity-75 cursor-not-allowed' : ''} bg-primary rounded uppercase text-center ${thin ? 'p-2' : 'p-4'} ${customWidth} text-white font-bold font-accent text-sm ${className}`}
      disabled={disabled || isLoading}
      {...props}
    >
      {
        isLoading ? (
          <Loader />
        ) : children
      }
    </button>
  )
}

export { Button }
